import { DOCUMENT, Injectable, inject, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ChartRecoveryService {
  private readonly document = inject(DOCUMENT);
  private readonly failed = signal(false);

  readonly chartRenderFailed = this.failed.asReadonly();

  markFailed(): void {
    this.failed.set(true);
  }

  reloadPage(): void {
    this.document.defaultView?.location.reload();
  }
}
